import { Box } from '@chakra-ui/react'
import { ToastContainer, Zoom } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ClientProvider } from './core/client/ClientProvider'
import { CLIENT_ID } from './core/client/buildConfig'
import { SidebarProvider } from './context/SidebarContext'

// App wraps children with ClientProvider (which includes ChakraProvider)
export const App = ({ children }: { children: React.ReactNode }) => (
  <ClientProvider clientId={CLIENT_ID}>
    <SidebarProvider>
      <Box h='100dvh'>
        {children}
        <ToastContainer
          position='top-right'
          autoClose={10000}
          hideProgressBar={true}
          transition={Zoom}
          pauseOnHover
        />
      </Box>
    </SidebarProvider>
  </ClientProvider>
)

export default App
